module.exports = __webpack_public_path__ + "files/0c20a54923c3a23993892e374c0e4a4e.png";